<div class="container-fluid">
    <iframe id="careerItem" width="100%" height="480" allow="autoplay"></iframe>

    <!-- <a href="/assets/pdf/Application form for the Post of Principal (2025).pdf" class="btn px-3 my-4"
        *ngIf="id === 'for-post-of-the-principal'" download>Click Here To Download The Application Form For The Post
        of Principal</a> -->
</div>